import React from 'react';
import CustomSelect from './CustomSelect';
import { useFormData } from '../hooks/useFormData';
import { companyKey } from '../utils/company';

/**
 * Company picker fed from the registered companies (Company page).
 * Replaces the old free-text input so a company can no longer be misspelled
 * or written with different casing. A stored value that matches a registered
 * company only loosely is displayed under its registered spelling; a value
 * that matches nothing (legacy data) is still listed, marked as such, so
 * editing an old record never silently blanks it.
 */
const CompanySelect = ({ name = 'company', value, onChange, required, className = 'form-select', placeholder = 'Select company…' }) => {
  const { companyNames } = useFormData();
  const current = String(value || '');
  const registered = companyNames.find((n) => companyKey(n) === companyKey(current));
  const shown = registered || current;

  return (
    <CustomSelect name={name} value={shown} onChange={onChange} required={required} className={className}>
      <option value="">{placeholder}</option>
      {companyNames.map((n) => <option key={n} value={n}>{n}</option>)}
      {current && !registered && <option value={current}>{current} (not in company list)</option>}
    </CustomSelect>
  );
};

export default CompanySelect;
